import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { ReportingCard }from "./component/Dashboard/ReportingCard";
import { FiShoppingCart, FiTrash2 } from 'react-icons/fi';
import { 
  LuTrendingUp,
   LuStore,
   LuTruck,
   LuPackage,
   LuFactory,
   LuPackageOpen,
   LuWarehouse,
   LuLandmark,
   LuFuel,
   LuPlane,
   LuBuilding2,
   LuArrowUpDown,
   LuArrowDownUp 
  } from 'react-icons/lu';
import GuidelineModalToggleButton from './component/Dashboard/GuidelineModalToggleButton';
import GuidelineModal from './component/Dashboard/GuidelineModal';

const scopeIIICards = [
  { icon: <FiShoppingCart className="w-5 h-5" />, title: "Purchased Goods & Services", description: "Emissions from the production of goods and services purchased by the organization.", link: "/scope-iii/purchased-goods-services", accentColor: "bg-card-accent-violet" },
  { icon: <LuLandmark className="w-5 h-5" />, title: "Capital Goods", description: "Emissions from the production of capital goods purchased by the organization.", link: "/scope-iii/capital-goods", accentColor: "bg-card-accent-sky" },
  { icon: <LuFuel className="w-5 h-5" />, title: "Fuel & Energy Related Activities", description: "Emissions from fuel and energy related activities not included in Scope 1 or 2.", link: "/scope-iii/fuel-energy-related-activities", accentColor: "bg-card-accent-orange" },
  { icon: <LuArrowUpDown className="w-5 h-5" />, title: "Upstream Transportation & Distribution", description: "Emissions from transporting and distributing products purchased by the organization.", link: "/scope-iii/upstream-transportation-distribution", accentColor: "bg-card-accent-blue" },
  { icon: <LuArrowDownUp className="w-5 h-5" />, title: "Downstream Transportation & Distribution", description: "Emissions from transporting and distributing sold products to end consumers.", link: "/scope-iii/downstream-transportation-distribution", accentColor: "bg-card-accent-teal" },
  { icon: <FiTrash2 className="w-5 h-5" />, title: "Waste Generated in Operations", description: "Emissions from disposal and treatment of waste generated in operations.", link: "/scope-iii/waste-generated", accentColor: "bg-card-accent-red" },
  { icon: <LuPlane className="w-5 h-5" />, title: "Business Travel", description: "Emissions from employee travel for business purposes across various transportation modes.", link: "/scope-iii/business-travel", accentColor: "bg-card-accent-blue" },
  { icon: <LuBuilding2 className="w-5 h-5" />, title: "Employee Commuting", description: "Emissions from employees traveling between home and worksites.", link: "/scope-iii/employee-commuting", accentColor: "bg-card-accent-pink" },
  { icon: <LuWarehouse className="w-5 h-5" />, title: "Upstream Leased Assets", description: "Emissions from assets leased by the organization not included in Scope 1 or 2.", link: "/scope-iii/upstream-leased-assets", accentColor: "bg-card-accent-teal" },
  { icon: <LuPackage className="w-5 h-5" />, title: "Downstream Leased Assets", description: "Emissions from assets owned by the organization and leased to others.", link: "/scope-iii/downstream-leased-assets", accentColor: "bg-card-accent-green" },
  { icon: <LuFactory className="w-5 h-5" />, title: "Processing of Sold Products", description: "Emissions from processing of intermediate products sold by the organization.", link: "/scope-iii/process-of-sold-products", accentColor: "bg-card-accent-pink" },
  { icon: <LuPackageOpen className="w-5 h-5" />, title: "Use of Sold Products", description: "Emissions from the use of goods and services sold by the organization.", link: "/scope-iii/use-of-sold-products", accentColor: "bg-card-accent-sky" },
  { icon: <LuTruck className="w-5 h-5" />, title: "End-of-Life Treatment of Sold Products", description: "Emissions from waste disposal and treatment of products sold by the organization.", link: "/scope-iii/sold-products-treatment", accentColor: "bg-card-accent-orange" },
  { icon: <LuStore className="w-5 h-5" />, title: "Franchises", description: "Emissions from the operation of franchises not included in Scope 1 or 2.", link: "/scope-iii/franchises", accentColor: "bg-card-accent-blue" },
  { icon: <LuTrendingUp className="w-5 h-5" />, title: "Investments", description: "Emissions from the organization's investments not included in Scope 1 or 2.", link: "/scope-iii/investments", accentColor: "bg-card-accent-purple" },
];

const ScopeIII = () => {
  const [isModalOpen, setModalOpen] = useState(false);
  const location  = useLocation()
  const { category } = location.state === null ? "" : location.state
  const handleToggleModal = () => setModalOpen(!isModalOpen);

  function cardCategory() {
    // const cards = {
    //   "Purchased Goods & Services": [<PurchasedGoodsAndServicesCard />, <CapitalGoodsCard />],
    //   "Fuels and Energy Related": [<FuelEnergyActivitiesCard/>],
    //   "Transportation and Distribution": [<UpstreamTransportationDistributionCard />, <DownstreamTransportationDistributionCard />],
    //   "Waste Generated": [<WasteGeneratedCard />],
    //   "Employee Travels": [<BusinessTravelCard />, <EmployeeCommutingCard />],
    //   "Leased Assets": [<UpstreamLeasedAssetsCard />, <DownstreamLeasedAssetsCard />],
    //   "Sold Products": [<ProcessOfSoldProductsCard/>, <UseOfSoldProductsCard/>, <SoldProductsTreatmentCard />],
    //   "Franchises & Investments": [<FranchisesCard />, <InvestmentsCard />]
    // }
    const cards = {
      "Purchased Goods & Services": scopeIIICards.slice(0, 2),
      "Fuels and Energy Related": scopeIIICards.slice(2, 3),
      "Transportation and Distribution": scopeIIICards.slice(3, 5),
      "Waste Generated": scopeIIICards.slice(5, 6),
      "Employee Travels": scopeIIICards.slice(6, 8),
      "Leased Assets": scopeIIICards.slice(8, 10),
      "Sold Products": scopeIIICards.slice(10, 13),
      "Franchises & Investments": scopeIIICards.slice(13)
    }
    if (category === ""){
      return Object.values(cards).flat()
    }
    else{
      return cards[category]
    }
  }

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto">
      <div className="mb-8 flex items-start justify-between">
        <div>
          <div className="flex items-center gap-2 mb-1">
            <span className="inline-block w-2 h-2 rounded-full bg-scope3" />
            <span className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Scope III</span>
          </div>
          <h1 className="text-3xl font-display font-bold text-foreground">Other Indirect Emissions</h1>
          <p className="text-muted-foreground mt-2 max-w-xl">
            All other indirect emissions that occur in your organization's value chain.
          </p>
        </div>
        <GuidelineModalToggleButton onClick={() => setModalOpen(true)} />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5">
        {cardCategory().map((card, i) => (
          <div key={card.title} className="animate-fade-in-up" style={{ animationDelay: `${i * 60}ms` }}>
              <ReportingCard {...card} />
          </div>
        ))}
      </div>

      {/* <div className={`flex flex-col lg:flex-row grid ${category === "" ? "grid-cols-3" : "grid-flow-col auto-cols-max"} gap-y-10 justify-around items-center pt-10 px-1 lg:pl-15 xl:pl-20 text-white`}>
        {cardCategory().map((card) => (
          card
        ))}
      </div> */}

       <GuidelineModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        title="Scope III — Other Indirect Emissions"
        subtitle="GHG Protocol Guidelines"
        content={
          <div className="space-y-3">
            <p>Scope III encompasses all other indirect emissions occurring in a company's value chain. These are typically the largest share of a company's carbon footprint.</p>
            <p className="font-medium">The 15 categories include:</p>
            <ul className="list-disc pl-5 space-y-1">
              <li>Purchased goods & services and capital goods</li>
              <li>Fuel & energy related activities</li>
              <li>Upstream & downstream transportation and distribution</li>
              <li>Waste generated in operations</li>
              <li>Business travel and employee commuting</li>
              <li>Upstream & downstream leased assets</li>
              <li>Processing, use, and end-of-life treatment of sold products</li>
              <li>Franchises and investments</li>
            </ul>
          </div>
        }
      />
    </div>
  );
};

export default ScopeIII;
